/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */
import { List } from '../PRIVATE_List';
import { ListProps } from './List.types';

/**
 * Props for the ListView Component
 */
export type Props<K, D> = Pick<
  ListProps<K, D>,
  | 'accessibleSummary'
  | 'children'
  | 'currentKey'
  | 'currentItemVariant'
  | 'data'
  | 'gridlines'
  | 'onCurrentKeyChange'
  | 'onItemAction'
  | 'onLoadRange'
  | 'onSelectionChange'
  | 'selectedKeys'
  | 'selectionMode'
  | 'viewportConfig'
>;

/**
 * Component that renders items as a flat list.
 * This component is nom-virtualized and renders all rows provided in the data prop.
 */
export function ListView<K extends string | number, D>(props: Props<K, D>) {
  return (
    <List isVirtualized={false} {...props}>
      {props.children}
    </List>
  );
}
